<template>
    <div>
        <el-row>
            <el-col :span="24">
                <Head>
                    <template v-slot:title>
                        <span style="margin-left:30%;"></span>
                    </template>
                </Head>
            </el-col>
        </el-row>
        <el-row class="row-top" type="flex" justify="center">
            <el-col :span="15">
                <auditList v-if="isShow" @statusFun="getStatus" :type="type" ></auditList>
                <fieldXq v-else @statusFun="getStatus" :item="itemData"></fieldXq>
            </el-col>
        </el-row>


    </div>
</template>
<script>
import Head from '@/components/header/head.vue';
import auditList from '@/components/audit/audit_list.vue';
import fieldXq from '@/views/audit/field/field_particulars.vue';
export default {
    data(){
        return {
            isShow:true,
            // status:'',

            itemData:[],
            type:'1',
            // genre:'0'  // 0是油田、企业、灵活、见习认证   1是个人绑定
             
        }
    },
    methods:{
       getStatus(isShow,itemData){
        //    console.log(isShow)
           this.isShow = isShow
           if(itemData){
               this.itemData = itemData
           }
        //    console.log('parentItemData')
        //    console.log(itemData)
        //    console.log(status)
       }
    },
    components:{
        Head,
        auditList,
        fieldXq        
    },
    created(){
        // this.axiosGet(`/companyApprove/page?approveStatus=${}`).then((res)=>{

        // })
    }
}
</script>
<style lang="less" scoped>
        
</style>